const envs = {
  production: "production",
  staging: "staging",
  development: "development",
};

export default envs;
